import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class SidebarService {
  private expandedSubject = new BehaviorSubject<boolean>(false); 
  isExpanded$ = this.expandedSubject.asObservable();

  toggleSidebar() {
    this.expandedSubject.next(!this.expandedSubject.value); 
  }
}
